import React from 'react';
// components
import Form from '../../../components/Form/Form';
import { Link } from 'react-router-dom';
import FieldError from '../../../components/Form/FieldError';
import FormErrors from '../../../components/Form/FormErrors';
import Input from '../../../components/Input/Input';
import Button from '../../../components/Button/Button';
// utils
import { withFormik } from 'formik';
import * as yup from 'yup';
import { responseErrors } from '../../../utils/response';
// styles
import styles from '../PasswordRecovery.mod.css';

export const PasswordRecoveryForm = ({
  values,
  touched,
  errors = {},
  dirty,
  status = {},
  isSubmitting,
  handleChange,
  handleBlur,
  handleSubmit
}) =>
  status.submitted ? (
    <h2 className={styles.message}>
      We send you password recovery link to {values.email}.<br />
      Follow the link to continue.
    </h2>
  ) : (
    <Form className={styles.formWrapper} onSubmit={handleSubmit}>
      <h2 className={styles.title}>Send an email with the instructions to</h2>
      <FormErrors errors={errors} />

      <div className="form-control">
        <div className="field-wrapper">
          <Input
            name="email"
            placeholder="Email"
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            invalid={errors.email && touched.email}
          />
          <FieldError error={errors.email} touched={touched.email} />
        </div>
      </div>
      <div className={styles.buttons}>
        <Button type="submit" isLoading={isSubmitting} disabled={isSubmitting}>
          Send
        </Button>
        <Link className={styles.link} to="/login">
          Log In
        </Link>
      </div>
    </Form>
  );

export default withFormik({
  mapPropsToValues: () => ({ email: '' }),
  validationSchema: yup.object().shape({
    email: yup
      .string()
      .email('Invalid email address')
      .required('Email is required!')
  }),
  handleSubmit: (
    values,
    { setStatus, setSubmitting, setErrors, props: { onSubmit } }
  ) => {
    onSubmit({
      redirect_url: window.location.origin + '/password-reset',
      ...values
    })
      .then(() => {
        setSubmitting(false);
        setStatus({ submitted: true });
      })
      .catch(response => {
        setErrors(responseErrors(response));
        setSubmitting(false);
      });
  },
  displayName: 'PasswordRecoveryForm'
})(PasswordRecoveryForm);



// WEBPACK FOOTER //
// ./src/containers/PasswordRecovery/components/PasswordRecoveryForm.jsx